import Speaker01 from "@/assets/front/img/speakers/01 PJ.jpg";
import Speaker02 from "@/assets/front/img/speakers/02 MGM.jpg";
import Speaker03 from "@/assets/front/img/speakers/03 MH.jpeg";
import Speaker04 from "@/assets/front/img/speakers/04 AS.jpg";
import Speaker05 from "@/assets/front/img/speakers/05 LC.png";
import Speaker06 from "@/assets/front/img/speakers/06 AR.jpg";
import Speaker07 from "@/assets/front/img/speakers/07 CB.jpg";
import Speaker08 from "@/assets/front/img/speakers/08 JL.jpg";
import Speaker09 from "@/assets/front/img/speakers/09 FB.jpg";
import Speaker10 from "@/assets/front/img/speakers/10 MF.jpg";
import Speaker11 from "@/assets/front/img/speakers/11 FT.jpg";
import Speaker12 from "@/assets/front/img/speakers/12 FM.jpg";
import Speaker13 from "@/assets/front/img/speakers/13 TM.jpg";
import Speaker14 from "@/assets/front/img/speakers/14 MH.png";
import Speaker15 from "@/assets/front/img/speakers/15 SH.jpg";
import Speaker16 from "@/assets/front/img/speakers/16 CB.jpg";
import Speaker17 from "@/assets/front/img/speakers/17 LJ.jpg";
import Speaker18 from "@/assets/front/img/speakers/18 RW.jpg";
import Speaker19 from "@/assets/front/img/speakers/19 BM.jpg";
import Speaker20 from "@/assets/front/img/speakers/20 GS.jpg";

// Données temporaires remplaçant les données reçues de l'API
const speakers = [
  {
    id: 1,
    firstname: "Patricia",
    lastname: "Jacopin",
    phoneNumber: "+33 6 87 10 95 60",
    email: "patriciajacopin@hotmail.com",
    localization: "Strasbourg",
    avatar: Speaker01,
    speakerSince: "",
    status: "",
    memberSince: "",
  },
  {
    id: 2,
    firstname: "Maria Grazia",
    lastname: "Maffei",
    phoneNumber: "+352 621194778 / +39 380 2859557",
    email: "mariagrazia@ritrovarsi.eu",
    localization: "Luxembourg - Italie",
    avatar: Speaker02,
    speakerSince: "",
    status: "",
    memberSince: "",
  },
  {
    id: 3,
    firstname: "Myriam",
    lastname: "Habib",
    phoneNumber: "+55 11 996864941",
    email: "myriamhabib6@gmail.com",
    localization: "São Paulo - Brésil",
    avatar: Speaker03,
    speakerSince: "",
    status: "",
    memberSince: "",
  },
  {
    id: 4,
    firstname: "Arnaud",
    lastname: "Stoltz",
    phoneNumber: "+33 6 20 19 35 67",
    email: "arnaud.stoltz@nootoos.eu",
    localization: "Strasbourg - Grand-Est - Paris",
    avatar: Speaker04,
    speakerSince: "",
    status: "",
    memberSince: "",
  },
  {
    id: 5,
    firstname: "Lucie",
    lastname: "Chagneau",
    phoneNumber: "+33 7 86 13 81 90",
    email: "Chagneau.lucie@gmail.com",
    localization: "Auvergne - Rhône-Alpes",
    avatar: Speaker05,
    speakerSince: "",
    status: "",
    memberSince: "",
  },
  {
    id: 6,
    firstname: "Antoine",
    lastname: "Remazeilles",
    phoneNumber: "+33 6 42 34 40 51",
    email: "aremaz@gmail.com",
    localization: "Sud-Ouest - Nouvelle Aquitaine",
    avatar: Speaker06,
    speakerSince: "",
    status: "",
    memberSince: "",
  },
  {
    id: 7,
    firstname: "Carole",
    lastname: "Bordes",
    phoneNumber: "+262 692 44 73 36",
    email: "carole.bordes3@gmail.com",
    localization: "Ile de la Réunion",
    avatar: Speaker07,
    speakerSince: "",
    status: "",
    memberSince: "",
  },
  {
    id: 8,
    firstname: "Juliann",
    lastname: "Li",
    phoneNumber: "+31 6 29 43 40 55 / +852 5933 4416",
    email: "hello@juliannliu.com",
    localization: "Pays-Bas - Chine",
    avatar: Speaker08,
    speakerSince: "",
    status: "",
    memberSince: "",
  },
  {
    id: 9,
    firstname: "Fatima",
    lastname: "Benzermid",
    phoneNumber: "+33 3 88 15 59 60",
    email: "fatima.benzermid@pretexte.com",
    localization: "Strasbourg Alsace",
    avatar: Speaker09,
    speakerSince: "",
    status: "",
    memberSince: "",
  },
  {
    id: 10,
    firstname: "Michiko",
    lastname: "Foussadier",
    phoneNumber: "+33 6 09 05 11 27",
    email: "contact@michiko-fou.com",
    localization: "Paris - Île de France",
    avatar: Speaker10,
    speakerSince: "",
    status: "",
    memberSince: "",
  },
  {
    id: 11,
    firstname: "Frédéric",
    lastname: "Theismann",
    phoneNumber: "+33 7 67 32 76 47",
    email: "frederic@coherence.life",
    localization: "Luxembourg - Belgique - France",
    avatar: Speaker11,
    speakerSince: "",
    status: "",
    memberSince: "",
  },
  {
    id: 12,
    firstname: "Françoise",
    lastname: "Mazuir",
    phoneNumber: "+33 6 83 96 92 43",
    email: "francoise.mazuir2@gmail.com",
    localization: "Pays de Gex - Rhône-Alpes",
    avatar: Speaker12,
    speakerSince: "",
    status: "",
    memberSince: "",
  },
  {
    id: 13,
    firstname: "Thibault",
    lastname: "Mengin",
    phoneNumber: "+33 6 74 00 75 63",
    email: "thibault.mengin@gmail.com",
    localization: "Alsace - Lorraine",
    avatar: Speaker13,
    speakerSince: "",
    status: "",
    memberSince: "",
  },
  {
    id: 14,
    firstname: "Marc",
    lastname: "Heidmann",
    phoneNumber: "+33 6 45 49 79 24",
    email: "marc.heidmann@gmail.com",
    localization: "Sud-Est - Bretagne - Paris - Île de France",
    avatar: Speaker14,
    speakerSince: "",
    status: "",
    memberSince: "",
  },
  {
    id: 15,
    firstname: "Sébastien",
    lastname: "Hennequin",
    phoneNumber: "+33 6 60 74 25 76",
    email: "shennequin@troisquartscene.com",
    localization: "Paris - Île de France",
    avatar: Speaker15,
    speakerSince: "",
    status: "",
    memberSince: "",
  },
  {
    id: 16,
    firstname: "Cédric",
    lastname: "Bischetti",
    phoneNumber: "+33 7 76 89 54 73",
    email: "cedric.bischetti@nootoos.pro",
    localization: "Strasbourg - Alsace",
    avatar: Speaker16,
    speakerSince: "",
    status: "",
    memberSince: "",
  },
  {
    id: 17,
    firstname: "Lydia",
    lastname: "Jabelot",
    phoneNumber: "+590 690 34 26 06",
    email: "lydiajabelot33@gmail.com",
    localization: "Guadeloupe - Martinique",
    avatar: Speaker17,
    speakerSince: "",
    status: "",
    memberSince: "",
  },
  {
    id: 18,
    firstname: "Rachel",
    lastname: "Wolff",
    phoneNumber: "+33 6 60 51 74 51",
    email: "rachelwolff67@yahoo.fr",
    localization: "Strasbourg - Alsace",
    avatar: Speaker18,
    speakerSince: "",
    status: "",
    memberSince: "",
  },
  {
    id: 19,
    firstname: "Bernard",
    lastname: "Maufras",
    phoneNumber: "+33 6 88 38 02 63",
    email: "bernard.maufras@smart-group.fr",
    localization: "Strasbourg - Alsace - Paris - Île de France",
    avatar: Speaker19,
    speakerSince: "",
    status: "",
    memberSince: "",
  },
  {
    id: 20,
    firstname: "Gabriel",
    lastname: "Schermann",
    phoneNumber: "+33 6 31 20 54 36",
    email: "gabriel.schermann@gmail.com",
    localization: "Strasbourg - Alsace",
    avatar: Speaker20,
    speakerSince: "",
    status: "",
    memberSince: "",
  },
];

export default speakers;
